// Redesign Group 3: the review card's Exit goes back to where it was opened — ③ Ranking or
// ④ Review, with that page's filters — not always the job page. "Start review" hands its page's
// address over in history state (as "Sort selected" hands its rows, S16), kept out of the
// address. Anywhere else (the command palette, a notification, a reload) lands on the job.

declare module '@tanstack/react-router' {
  interface HistoryState {
    /** The address "Start review" was pressed on: the job's Ranking or Review page. */
    readonly reviewFrom?: string;
  }
}

const ORIGIN_STAGES: readonly string[] = ['ranking', 'review'];

/** Where Exit goes: the job's Ranking or Review page the card was opened from, else the job page. */
export function reviewCardExitHref(jobId: string, from: string | undefined): string {
  const jobPage = `/jobs/${jobId}`;
  if (from === undefined || !from.startsWith(`${jobPage}/`)) return jobPage;
  const stage = from.slice(jobPage.length + 1).split(/[/?#]/)[0] ?? '';
  return ORIGIN_STAGES.includes(stage) ? from : jobPage;
}
